import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import {
  BaseSemanalAlertaResponse,
  controleProducaoService,
} from "../../services/controleProducaoService";
import { canAccessPath, hasFullAccessUser } from "../../lib/screenAccess";

const DISMISS_KEY = "cp_base_alerta_dismiss";

const ControleProducaoBaseSemanalAlertBanner: React.FC = () => {
  const { user } = useAuth();
  const [alerta, setAlerta] = useState<BaseSemanalAlertaResponse | null>(null);
  const [dismissed, setDismissed] = useState(false);

  const isAdmin = hasFullAccessUser(user);
  const podeBase = canAccessPath(user, "/controle-producao/base-semanal");
  const podeFicha = canAccessPath(user, "/controle-producao/ficha-diaria");

  useEffect(() => {
    if (!user || !isAdmin || (!podeBase && !podeFicha)) {
      setAlerta(null);
      return;
    }

    const dismissDate = sessionStorage.getItem(DISMISS_KEY);
    if (dismissDate === new Date().toISOString().slice(0, 10)) {
      setDismissed(true);
    } else {
      setDismissed(false);
    }

    let cancelled = false;
    void controleProducaoService
      .getAlertaBaseSemanal(user.lojaId, { viaBase: podeBase })
      .then((data) => {
        if (!cancelled) setAlerta(data);
      })
      .catch(() => {
        if (!cancelled) setAlerta(null);
      });

    return () => {
      cancelled = true;
    };
  }, [user, isAdmin, podeBase, podeFicha]);

  if (!alerta?.exibirAlerta || dismissed) {
    return null;
  }

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, new Date().toISOString().slice(0, 10));
    setDismissed(true);
  };

  return (
    <div
      className="border-b border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950"
      role="alert"
    >
      <div className="mx-auto flex max-w-7xl items-start gap-3">
        <AlertTriangle
          className="mt-0.5 h-5 w-5 shrink-0 text-amber-600"
          aria-hidden
        />
        <div className="min-w-0 flex-1">
          <p className="font-semibold">Base semanal pendente</p>
          <p className="mt-0.5">{alerta.mensagem}</p>
          {podeBase && (
            <Link
              to="/controle-producao/base-semanal"
              className="mt-1 inline-block font-semibold text-amber-900 underline"
            >
              Ir para cadastro da base semanal
            </Link>
          )}
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="shrink-0 rounded p-1 text-amber-800 hover:bg-amber-100"
          aria-label="Fechar aviso até amanhã"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default ControleProducaoBaseSemanalAlertBanner;
